<template>
	<div>

		<div class="container">
			<div class="logoBox">
				<div class="logoMark" style="padding: 10px;">
					<!--<div class="logoText">AGE</div>-->
					<img src="images/logo_3.png" style="width: 100%;" />
				</div>
			</div>

			<div class="banner section">
				<div class="big"><span data-lang="t_22"></span><span
						style="color: aqua;">{{"#" + Number(userID).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="big"><span data-lang="t_23"></span><span
						style="color: aqua;">{{"#" + Number(RefId).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="small">
					<span class="big" style="color: azure;">{{userTitle}}：</span>
					<span style="color: #F00;font-size: 1.2rem;">{{userType}}</span>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px">
					<div>
						<div class="title" data-lang="t_24"></div>
						<div class="muted" >AGE平台VIP奖励公告</div>
						<div class="muted" >AGE平台创世节点行动公告</div>
						<div class="muted" >AGE平台完全放弃权限公告</div>
					</div>
					<div>
						<div class="muted" >
							<button class="btn btn-mini" @click="Announcement = 1" data-lang="t_26"></button>
						</div>
						<div class="muted" >
							<button class="btn btn-mini" @click="Announcement = 2" data-lang="t_26"></button>
						</div>
						
						<div class="muted" >
							<button class="btn btn-mini" @click="Announcement = 3" data-lang="t_26"></button>
						</div>
					</div>
									
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px 14px 0">
					<div class="h2" data-lang="t_27"></div>
					<span class="pill" data-lang="t_28"></span>
				</div>
				<div class="list" style="padding:14px">
					<TeamTreeNode v-for="item in teamData" :key="item.id" :node="item" />
				</div>
			</div>
		</div>

		<!-- 公告弹窗 -->
		<div class="modalMask" :class="{show:Announcement > 0}">
			<div class="modal">
				<div class="modalHead">
					<div>公告</div>
					<div class="modalClose" @click="Announcement = 0">×</div>
				</div>
				<div class="modalBody">
					<div v-if="Announcement == 1" class="reward_container">
						<div class="reward_title">AGE平台VIP奖励公告</div>
						
						<div class="reward_intro">
							为感谢广大用户对AGE生态的支持与热爱，阿尔法基金会现推出VIP奖励计划（先到先得，额满即止）：
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">前30名达到V2级的用户</span>
								<span class="reward_desc">赠送最新款<span class="reward_highlight">苹果iPad</span>一台</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">前20名达到V3级的用户</span>
								<span class="reward_desc">赠送<span
										class="reward_highlight">20克纯金AGE限量版纪念币</span>一枚</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">前10名达到V4级的用户</span>
								<span class="reward_desc">可二选一：<span class="reward_highlight">劳力士金表</span>一枚或等值<span
										class="reward_highlight">18000 USDT</span>奖励</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">前5名达到V5级的用户</span>
								<span class="reward_desc">赠送<span class="reward_highlight">玛莎拉蒂豪华轿车</span>一辆，并享有平台<span
										class="reward_highlight">2%的加权分红</span></span>
							</div>
						</div>
						
						<div class="reward_call">** 立即行动，锁定您的专属奖励！</div>
						
						<div class="reward_contact">
							活动细则及实时进度，请联系官方客服或社区管理员。
						</div>
					</div>
					<div  v-if="Announcement == 2"  class="reward_container">
						<div class="reward_title">AGE平台创世节点行动公告</div>
						<div class="reward_intro">
							为促进AGE健康发展，筛选出真正的行业精英，清理掉不作为的创世节点，AGE平台决定对创世节点的业绩进行评估
						</div>
						<!--
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">从2026年2月24到3月1日</span>
								<span class="reward_desc">每个创世节点必须售出至少<span class="reward_highlight">1000AGE</span>，完不成业绩任务的创世节点，永久冻结</span>
							</div>
						</div>-->
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">从2026年3月1到4月1日</span>
								<span class="reward_desc">每个创世节点必须售出一期产出的<span class="reward_highlight">7650AGE</span>，完不成业绩任务的创世节点，永久冻结</span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">丢弃管理权限时间：第一期结束冻结完成后</span>
								<span class="reward_desc">AGE平台<span class="reward_highlight">丢弃管理权限</span>，平台运作完全由市场驱动</span>
							</div>
						</div>
						<div class="reward_footer">
							<div>阿尔法基金会保留最终解释权。</div>
							<div class="reward_date">（公告日期：2026年2月24日）</div>
						</div>
					</div>
					<div  v-if="Announcement == 3"  class="reward_container">
						<div class="reward_title">AGE平台放弃权限公告</div>
						<div class="reward_intro">
							为促进AGE健康发展，项目方已完全放弃管理权限
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">丢弃管理权限时间：2026年4月22日</span>
								<span class="reward_desc">AGE平台<span class="reward_highlight">已完全丢弃管理权限</span>，平台运作完全由市场驱动</span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">矿机管理权限</span>
								<span class="reward_desc">合约地址<span class="reward_highlight">0xDE439e433FC73F36D17eEA8Af578a918AE9977D6</span></span>
								<span class="reward_desc">权限<span class="reward_highlight">Address9 已由原来的管理员地址改为 0x0000000000000000000000000000000000000001</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">交易管理权限</span>
								<span class="reward_desc">合约地址<span class="reward_highlight">0x74051773CDE93487De1FD771642eF2335dda3d31</span></span>
								<span class="reward_desc">权限<span class="reward_highlight">Address7 已由原来的管理员地址改为 0x0000000000000000000000000000000000000001</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">代币管理权限</span>
								<span class="reward_desc">合约地址<span class="reward_highlight">0x5656f5331f80beDefB0249c342aB009d9c7b1F78</span></span>
								<span class="reward_desc">权限<span class="reward_highlight">owner 已由原来的管理员地址改为 0x0000000000000000000000000000000000000000</span></span>
							</div>
						</div>
						<div class="reward_footer">
							<div>阿尔法基金会保留最终解释权。</div>
							<div class="reward_date">（公告日期：2026年4月22日）</div>
						</div>
					</div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="Announcement = 0">关闭</button>
				</div>
			</div>
		</div>

		<!-- Bottom Nav -->
		<div class="bottom">
			<div class="bottom-inner">
				<div class="nav active">
					<i class="fas fa-home"></i>
					<span data-lang="t_2"></span>

				</div>
				<div class="nav" data-lang="t_3"></div>
				<div class="nav" data-lang="t_4"></div>
				<div class="nav" data-lang="t_5"></div>
			</div>
		</div>
	</div>


</template>

<script>
	import TeamTreeNode from './child/TeamTreeNode.vue'
	export default {
		name: 'Home',
		components: {
			TeamTreeNode
		},
		data() {
			return {
				userID: 0,
				RefId: 0,
				userTitle: "",
				userType: "",
				teamData: [],
				Announcement: 0, //公告
			}
		},
		mounted() {
			if(IsShowAnnouncement == true){
				IsShowAnnouncement = false;
				this.Announcement = 3;
			}
			this.setLanguage();
			this.showUI();
		},
		methods: {
			setLanguage() {
				const elements = document.querySelectorAll('[data-lang]');

				elements.forEach(element => {
					const langValue = element.getAttribute('data-lang');

					element.innerHTML = Lang[lg][langValue];
				});
			},
			async showUI() {

				const user = await conMine.getPeopleTree(Account).call();
				this.userID = user.id //Number(user.id).toString(16);
				this.RefId = user.fatherNode //Number(user.fatherNode).toString(16);
				if (user.Type == 1) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_3;
				} else if (user.Type == 2) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_33;
				} else if (user.Type == 3 || user.Type == 11) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_34;
				} else if (user.Type == 4 || user.Type == 12) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_35;
				}
				await Sleep(this.$waitTime);
				const child = await conMine.GetBrother(user.childNode, 100).call();

				if (child == null) return;
				const len = child.length;
				let point = 2;

				let index = 0;
				let team = [];
				while (point < len) {
					team[index] = {};
					team[index].id = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].people = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].totalMine = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].leval = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].quickenFloor = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].children = []; // 存储下级数据
					team[index].expanded = false; // 控制是否展开
					team[index].id = team[index].id.toString(16).toLocaleUpperCase(); //转换成16进制
					index++;
				}
				this.teamData = team;
			},
		},
	}
</script>
<style>
	.reward_container {

		color: #ffffff;
		font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;

		max-width: 800px;
		line-height: 1.7;

	}

	.reward_title {
		color: #00ffff;
		text-align: center;
		font-size: 1.5rem;
		margin-bottom: 6px;
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(0, 255, 255, 0.3);
		text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
		letter-spacing: 2px;
	}

	.reward_intro {
		color: #cccccc;
		font-size: 0.8rem;
		margin-bottom: 25px;
		text-align: left;
		padding: 0 10px;
	}

	.reward_list {
		margin: 10px 0;
		padding-left: 0;
	}

	.reward_item {
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.05), rgba(0, 255, 255, 0.02));
		border-left: 4px solid #00ffff;
		margin-bottom: 5px;
		padding: 6px 12px;
		border-radius: 0 8px 8px 0;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		text-align: left;
	}

	.reward_item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 0;
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.1), transparent);
		transition: width 0.5s ease;
	}

	.reward_item:hover::before {
		width: 100%;
	}

	.reward_item:hover {
		transform: translateX(5px);
		box-shadow: 0 5px 15px rgba(0, 255, 255, 0.1);
	}

	.reward_level {
		color: #00ffff;
		font-weight: bold;
		font-size: 0.85rem;
		margin-bottom: 8px;
		display: block;
	}

	.reward_desc {
		color: #e0e0e0;
		font-size: 0.75rem;
	}

	.reward_highlight {
		color: #ffcc00;
		font-weight: bold;
		text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
	}

	.reward_call {
		text-align: center;
		font-size: 1.0rem;
		font-weight: bold;
		color: #00ffaa;
		margin: 6px 0;
		padding: 6px;
		background: rgba(0, 255, 170, 0.08);
		border-radius: 10px;
		border: 1px solid rgba(0, 255, 170, 0.2);
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0.4);
		}

		70% {
			box-shadow: 0 0 0 10px rgba(0, 255, 170, 0);
		}

		100% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0);
		}
	}

	.reward_contact {
		color: #aaaaaa;
		font-size: 0.7rem;
		text-align: center;
		margin: 6px 0;
		padding: 6px;
		background: rgba(255, 255, 255, 0.03);
		border-radius: 6px;
	}

	.reward_footer {
		font-size: 0.6rem;
		color: #888888;
		text-align: center;
		margin-top: 12px;
		padding-top: 6px;
		border-top: 1px solid #333333;
	}

	.reward_date {
		color: #999999;
		font-style: italic;
		margin-top: 5px;
	}
</style>